import { axiosB2 } from './axiosB2';

/**
 * @typedef {object} B2Envelope
 * @property {string|number} [State]
 * @property {string|number} [state]
 * @property {*} [Result]
 * @property {*} [result]
 * @property {*} [data]
 * @property {string} [Message]
 * @property {string} [message]
 */

/**
 * Parse B2 JSON/string envelope from axios `data`; throws on parse failure, empty body, or non-success State.
 * Success State is `1` or `'1'`. If `State`/`state` is absent, the envelope is accepted.
 * @param {string|object|null|undefined} data
 * @returns {B2Envelope} parsed envelope
 */
export function parseB2Envelope(data) {
    let parsed;
    try {
        parsed = typeof data === 'string' ? JSON.parse(data) : data;
    } catch {
        throw new Error('Invalid B2 response: JSON parse error');
    }
    if (parsed == null) {
        throw new Error('Empty B2 response');
    }
    const state = parsed.State ?? parsed.state;
    if (state !== undefined && state !== null && state !== '1' && state !== 1) {
        const msg = parsed.Message || parsed.message || 'B2 error';
        throw new Error(typeof msg === 'string' ? msg : 'B2 error');
    }
    return parsed;
}

/**
 * @param {B2Envelope} envelope
 * @returns {*}
 */
export function getB2Result(envelope) {
    return envelope.Result ?? envelope.result;
}

/**
 * @param {B2Envelope} envelope
 * @param {string} [message='B2 response missing Result']
 * @returns {*}
 */
export function getB2ResultOrThrow(envelope, message = 'B2 response missing Result') {
    const result = getB2Result(envelope);
    if (result === undefined) {
        throw new Error(message);
    }
    return result;
}

/**
 * MarketingConsent-style payload: `data` → `Result`/`result` → whole envelope.
 * @param {B2Envelope} envelope
 * @returns {*}
 */
export function getB2Payload(envelope) {
    if (envelope.data !== undefined) {
        return envelope.data;
    }
    const result = getB2Result(envelope);
    if (result !== undefined) {
        return result;
    }
    return envelope;
}

/**
 * @param {string} action B2 SOAP action name
 * @param {object} [body]
 * @returns {Promise<B2Envelope>}
 */
export function postB2(action, body) {
    return axiosB2.post(action, body).then(({ data }) => parseB2Envelope(data));
}

/**
 * @param {string} action B2 SOAP action name
 * @param {object} [body]
 * @returns {Promise<*>}
 */
export function postB2Result(action, body) {
    return postB2(action, body).then(getB2Result);
}
